import { render, staticRenderFns } from "./accordionType.vue?vue&type=template&id=4d745803&scoped=true&"
import script from "./accordionType.vue?vue&type=script&lang=js&"
export * from "./accordionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d745803",
  null
  
)

export default component.exports